import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  quickLinks: [],
  ownedCourses: [],
  enrolledCourses: [],
  planningStream: {},
  dashboardPlanning: [],
  eventRecommendations: [],
  clubRecommendations: [],
  jobRecommendations: [],
  learnerDashboardState: {},
  learnerDashboardComponents: []
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/dashboard/vuex/index.js